// src/BrandWall.jsx
import React from "react";
import brands from "./brands";
import "./BrandWall.css";

/**
 * "Brands I've Worked With" — a static logo grid, greyscale at rest and full
 * colour on hover or keyboard focus.
 *
 * Deliberately not a marquee: the tools row above is already in motion, and a
 * second scrolling strip reads as decoration. Credibility wants to sit still
 * and be scanned.
 *
 * Renders nothing until src/brands.js has entries, so a half-finished list
 * never leaves a heading stranded over empty space.
 */
export default function BrandWall({
  title = "Brands I've Worked With",
  kicker,
}) {
  if (!brands || brands.length === 0) return null;

  return (
    <section
      id="brands"
      className="section brand-wall"
      aria-labelledby="brands-title"
    >
      {kicker && <p className="brand-wall-kicker">{kicker}</p>}
      <h2 id="brands-title">{title}</h2>

      <ul className="brand-wall-grid">
        {brands.map(({ name, src, href }) => (
          <li className="brand-item" key={name}>
            {href ? (
              <a
                className="brand-link"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                /* the visible logo carries the name, so label the link itself */
                aria-label={`${name} (opens in a new tab)`}
              >
                <img className="brand-logo" src={src} alt={name} loading="lazy" />
              </a>
            ) : (
              <img className="brand-logo" src={src} alt={name} loading="lazy" />
            )}
          </li>
        ))}
      </ul>
    </section>
  );
}
